import React, { useEffect, useState } from "react";
import styles from "./PracticeDetailsPage.module.scss";
import Header from "../Header/header";
import SetupSteps, { Step } from "../Register/SetupSteps/SetupSteps";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const STEPS: Step[] = [
  { key: "practice", label: "Practice and personal info", path: "/practiceDetails" },
  { key: "logo", label: "Logo Management", path: "/logoManagement" },
  { key: "social", label: "Social Media Links", path: "/socialLinks" },
  { key: "portfolio", label: "Portfolio Gallery", path: "/portfolio-gallery" },
  { key: "consent", label: "Consent Templates", path: "/consent-templates" },
  { key: "preview", label: "Preview & Complete", path: "/preview" },
];

export default function PracticeDetailsPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    practiceName: "",
    practiceMobile: "",
    address: "",
    practiceEmail: "",
  });

  const [user, setUser] = useState<any>(null);
  const [practitioner, setPractitioner] = useState<any>(null);

  useEffect(() => {
    const fetchPracticeData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL_V2}onboarding/get_practice_data`
        );

        setForm({
          practiceName: res.data?.name || "",
          practiceMobile: res.data?.contact_no || "",
          address: res.data?.address || "",
          practiceEmail: res.data?.email || "",
        });
      } catch (err) {
        console.error("Error fetching practice data:", err);
      }
    };

    const fetchUserData = async () => {
      try {
        const { data } = await axios.get("/user");
        if (Array.isArray(data) && data.length > 1) {
          setUser(data[1]);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };

    const fetchPractitionerData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL_V2}onboarding/get_practitioner_data`
        );
        setPractitioner(res.data);
      } catch (err) {
        console.error("Error fetching practitioner data:", err);
      }
    };

    fetchPracticeData();
    fetchUserData();
    fetchPractitionerData();
  }, []);

  return (
    <div className={styles.page}>
      <Header />

      <main className={styles.main}>
        <SetupSteps
          steps={STEPS}
          current={1}
          rightLabel="0% Complete"
          onStepClick={(step) => navigate(step.path)}
        />

        <h1 className={styles.title}>Practice details</h1>
        <p className={styles.subtitle}>
          To create a consent request, you’ll need both your patient’s details
          and your practice information. Don’t worry, this information is
          pre-filled from DENTALLY, so just review and continue.
        </p>

        {/* Practice Information */}
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Practice information</h2>

          <div className={styles.grid}>
            <div className={styles.field}>
              <label>Name</label>
              <input value={form.practiceName} disabled />
            </div>

            <div className={styles.field}>
              <label>Mobile</label>
              <input value={form.practiceMobile} disabled />
            </div>

            <div className={`${styles.field} ${styles.colSpanFull}`}>
              <label>Address</label>
              <textarea rows={2} value={form.address} disabled />
            </div>

            <div className={styles.field}>
              <label>Practice email</label>
              <input value={form.practiceEmail} disabled />
            </div>
          </div>
        </section>

        {/* Personal Info */}
        {user?.level === "user" && practitioner && (
          <section className={styles.card}>
            <h2 className={styles.cardTitle}>Personal information</h2>

            <div className={styles.grid}>
              <div className={styles.field}>
                <label>Full name</label>
                <input value={practitioner.name || ""} disabled />
              </div>

              <div className={styles.field}>
                <label>Title / Credentials</label>
                <input value={practitioner.role || ""} disabled />
              </div>

              <div className={styles.field}>
                <label>Personal email</label>
                <input value={practitioner.email || ""} disabled />
              </div>

              <div className={styles.field}>
                <label>GDC Number</label>
                <input value={practitioner.gdc_number || ""} disabled />
              </div>

              <div className={styles.field}>
                <label>NHS Number</label>
                <input value={practitioner.nhs_number || ""} disabled />
              </div>
            </div>
          </section>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btnSecondary}
            onClick={() => navigate(-1)}
          >
            Back
          </button>

          <button
            type="button"
            className={styles.btnPrimary}
            onClick={() => navigate("/logoManagement")}
          >
            Next
          </button>
        </div>
      </main>

      <footer className={styles.footer}>
        Copyright © Medicube 2025. All Rights Reserved.
      </footer>
    </div>
  );
}
